import React, { useContext, useRef, useState } from 'react';
import './Contact.css';
import emailjs from 'emailjs-com';
import { ThemeContext } from '../../context';

const Contact = () => {
    const formRef = useRef();
    const [done, setDone] = useState(false);
    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode;

    const handleSubmit =(e) =>{
        e.preventDefault()
        emailjs.sendForm('service_fav3eo9', 'template_yrue287', formRef.current, 'user_VHQLJBKBrpoW2X8U0sYQP')
      .then((result) => {
          console.log(result.text);
          setDone(true);
      }, (error) => {
          console.log(error.text);
      });
    }
    return (
        <div data-aos="fade-up"
        data-aos-duration="3000" className='c'>
            <div className="c-bg"></div>
                <div className="c-wrapper">
                    <div className="c-left">
                        <h1 className="c-title"><span style={{color:darkMode ? "gray" : 'rgb(1, 57, 61)'}}>C</span>ontact Me</h1>
                        <div className="c-info">
                            <div className="c-info-item">
                            <i className="fas fa-phone c-icon"></i>+880 1766548835 
                            </div>
                        </div>
                        <div className="c-info">
                            <div className="c-info-item">
                            <i className="fas fa-envelope c-icon"></i> ijsathi2001rs@gmail.com
                            </div>
                        </div>
                        <div className="c-info">
                            <div className="c-info-item">
                            <i class="fas fa-map-marker-alt c-icon"></i> Dhaka 1207, Bangladesh
                            </div>
                        </div>
                        <div className="c-info">
                            <div className="c-info-item">
                            <a href="https://www.linkedin.com/in/ijsathi/"><i style={{color: darkMode && "white" }} class="fab fa-linkedin c-icon"> </i></a> Israt Zahan Sathi
                            </div>
                        </div>
                    </div>
                    <div className="c-right">
                            <p className="c-desc">
                                <b>Want to contact me?</b>  Then mail it
                            </p>
                            <form ref={formRef} onSubmit={handleSubmit}>
                            <input style={{backgroundColor: darkMode && "#333"}} type="text" placeholder="Name" name="user_name" />
                            <input style={{backgroundColor: darkMode && "#333"}} type="text" placeholder="Subject" name="user_subject" />
                            <input style={{backgroundColor: darkMode && "#333"}} type="text" placeholder="Email" name="user_email" />
                            <textarea style={{backgroundColor: darkMode && "#333"}} name="message" placeholder="Massage" rows="5"></textarea>
                            <button style={{backgroundColor: darkMode && "rgb(1, 27, 29)"}} className='btn'>Submit</button>
                            {done && "Thank You for sharing your message!!"}
                            </form>
                    </div>
                </div>
        </div>
    );
};

export default Contact;